import { SPACING, TYPOGRAPHY } from '@dale/react-bacan-ui';
import styled from 'styled-components';

export const AddPhoneNumberPStyled = styled.p`
  ${TYPOGRAPHY['subheading-L6']}
  text-align: center;
`;

export const PhoneContainerStyled = styled.div`
  width: 100%;
  margin: ${SPACING['24']}px 0;
`;

export const TermsContainerStyled = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${SPACING['24']}px;
`;

export const AcceptTermsPStyled = styled.p`
  ${TYPOGRAPHY['subheading-L7']};
  margin-left: ${SPACING['8']}px;
  margin-bottom: 0;
`;

export const TermsPStyled = styled.span`
  ${TYPOGRAPHY['heading-L7']};
  text-decoration: underline;
  cursor: pointer;
`;